<template>
  <!-- Loading -->
  <div class="text-center">
    <h2>
      <span class="align-middle ml-50">Cerrando sesión...</span>
    </h2>
  </div>
</template>

<script>
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'

export default {
  mounted() {
    this.logout()
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      localStorage.setItem('logout', true)

      window.location.href = process.env.VUE_APP_LOGIN_URL
      // Redirect to login page
      // this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
